'use client'

import { useEffect } from 'react'

import { ErrorPageContent } from '@/app/components/ErrorPageContent'

export default function Error({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error)
  }, [error])

  return (
    <ErrorPageContent
      page={null}
      fallbackTitle="Something went wrong!"
      fallbackMessage="An error occurred while loading this page."
    />
  )
}
